import { getAlgorithmList, getAssessmentAlgorithm } from "@/ipc/api";

declare global {
  interface Window {
    /**
     * 典公钥
     */
    DIANSHU_PKEY: string;
    /**
     * 发布数据的算法 Hash
     */
    DIANSHU_ALGORITHM_HASH: string;
    /**
     * 发布数据的算法 id
     */
    DIANSHU_ALGORITHM_ID: string;
    /**
     * 购买数据的算法 Hash
     */
    DIANSHU_BUY_ALGORITHM_HASH: string;
    /**
     * 购买数据的算法 id
     */
    DIANSHU_BUY_ALGORITHM_ID: string;
  }
}

async function init() {
  console.time("Global Initialization");
  const list = await getAlgorithmList();
  const algorithm = await getAssessmentAlgorithm("download");
  const payAlgorithm = await getAssessmentAlgorithm("payAlgorithm");
  window.DIANSHU_PKEY = list[0].publicKey || process.env.VUE_APP_PKEY || "";
  window.DIANSHU_ALGORITHM_HASH =
    (algorithm && algorithm.length && algorithm[0].hash) ||
    process.env.VUE_APP_ALGORITHM_HASH ||
    "";
  window.DIANSHU_ALGORITHM_ID =
    ((algorithm && algorithm.length && algorithm[0].id) ||
      process.env.VUE_APP_ALGORITHM_ID) + "";

  window.DIANSHU_BUY_ALGORITHM_HASH =
    (payAlgorithm && payAlgorithm.length && payAlgorithm[0].hash) ||
    process.env.VUE_APP_BUY_ALGORITHM_HASH ||
    "";
  window.DIANSHU_BUY_ALGORITHM_ID =
    ((payAlgorithm && payAlgorithm.length && payAlgorithm[0].id) ||
      process.env.VUE_APP_BUY_ALGORITHM_ID) + "";
  console.timeEnd("Global Initialization");
}

init();
